module.exports = __webpack_public_path__ + "images/defualt_background_7befd195365c586b1ebfac6a64e7aae2.jpg";